import 'whatwg-fetch';
import React from 'react';
import { Router } from 'react-router-dom';
import { LastLocationProvider } from 'react-router-last-location';
import { Provider } from 'react-redux';
import { change } from 'redux-form';
import createStore from './src/redux/createStore';
import { fetchApi } from './src/utils/fetch';
import readCookie from './src/utils/readCookie';
import { setLoggedInStatus } from './src/actionCreators';
import {
  createCookie,
  getQueryParameterByName,
} from './src/utils/params';

const store = createStore();
const enableHeap = false;

/*eslint-disable */
exports.replaceRouterComponent = ({ history }) => {
  const ConnectedRouterWrapper = ({ children }) => (
    <Provider store={store}>
      <Router history={history}>
        <LastLocationProvider>{children}</LastLocationProvider>
      </Router>
    </Provider>
  );

  return ConnectedRouterWrapper;
};

exports.onClientEntry = () => {
  if (window.ga) {
    window.ga('require', 'GTM-KV9K8W9');
  }

  fetchApi('GET', '/api/user/quick/')
    .then(data => {
      const username = data.first_name || data.username;
      const { id, email, company_name, label, occupation, token } = data;
      const isSubscribed = data.is_subscribed;
      const testGroupNumber = readCookie('test_group_number');
      store.dispatch(
        setLoggedInStatus({
          isLoggedIn: true,
          isSubscribed,
          username,
          email,
          companyName: company_name,
          testGroupNumber: testGroupNumber && Number(testGroupNumber),
        })
      );
      // We want to fill in the enterpriseForm if possible as it will allow users to contact us more clearly
      store.dispatch(change('enterpriseForm', 'email', email));
      store.dispatch(change('enterpriseForm', 'name', username));
      store.dispatch(change('enterpriseForm', 'companyName', company_name));
      if (window.heap) {
        heap.identify(id);
      }
      const userDetails = {
        email: email,
        company: company_name,
        name: username,
        planType: label,
        occupation: occupation,
        userJwt: token,
      };
    })
    .catch(() => {
      const testGroupNumber = readCookie('test_group_number');
      store.dispatch(
        setLoggedInStatus({
          isLoggedIn: false,
          isSubscribed: false,
          testGroupNumber: testGroupNumber && Number(testGroupNumber),
        })
      );
    });

  // Save any params that are sent through and save them as a cookie if we need them
  const gclid = getQueryParameterByName('gclid');
  if (gclid) {
    createCookie('gclid', gclid);
  }
  const fbclid = getQueryParameterByName('fbclid');
  if (fbclid) {
    createCookie('fbclid', fbclid);
  }
};

exports.onInitialClientRender = () => {
  let hash = window.location.hash;

  if (hash) {
    hash = hash.substring(hash.indexOf('#') + 1);
    setTimeout(() => {
      const targetElement = document.getElementById(hash);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'start',
        });
      }
    }, 50);
  }
};

exports.onRouteUpdate = ({location}) => {
  // Don't call the hubpsot setPath method on the initial page load
  // as it's breaking hubspots attribution tracking
  if (window.initialPageRender) {
    const _hsq = (window._hsq = window._hsq || []);
    _hsq.push(['setPath', location.pathname]);
    _hsq.push(['trackPageView']);
  } else {
    window.initialPageRender = true;
  }
};
/*eslint-enable */



// WEBPACK FOOTER //
// ./gatsby-browser.js